
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { YouTubeVideo, extractVideoId } from '@/services/youtubeVideoService';

interface YouTubeVideoModalProps {
  video: YouTubeVideo;
  open: boolean;
  onClose: () => void;
}

export const YouTubeVideoModal: React.FC<YouTubeVideoModalProps> = ({
  video,
  open,
  onClose,
}) => {
  const videoId = extractVideoId(video.youtube_url);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>{video.title || 'YouTube Video'}</DialogTitle>
        </DialogHeader>
        <div className="aspect-video">
          {videoId ? (
            <iframe
              src={`https://www.youtube.com/embed/${videoId}`}
              title={video.title || 'YouTube Video'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full rounded-md"
            />
          ) : (
            <div className="flex items-center justify-center h-full bg-muted rounded-md">
              <p className="text-muted-foreground">Invalid video URL</p>
            </div>
          )}
        </div>
        {video.notes && (
          <div className="mt-4">
            <h4 className="font-medium mb-2">Notes</h4>
            <p className="text-sm text-muted-foreground">{video.notes}</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
